import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageModule } from '../language/language.module';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslationModule } from '../translation/translation.module';
import { ShoppingcartModule } from '../shoppingcart/shoppingcart.module';
import { FooterModule } from '../footer/footer.module';
import { BannersComponent } from './banners.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpdatebannerComponent } from './updatebanner/updatebanner.component';
import { OrderBannersComponent } from './orderbanners/orderbanners.component';
import { DeletebannerpopupComponent } from './deletebannerpopup/deletebannerpopup.component';
import { AddbannerComponent } from './addbanner/addbanner.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FilterModule } from '../filter/filter.module';
import { MatdialogModule } from '../matdialog/matdialog.module';



@NgModule({
    declarations: [BannersComponent, UpdatebannerComponent,OrderBannersComponent,DeletebannerpopupComponent,AddbannerComponent],
    exports: [BannersComponent,UpdatebannerComponent,OrderBannersComponent,DeletebannerpopupComponent,AddbannerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],

    imports: [
        CommonModule,
        LanguageModule,
        RouterModule,
        TranslationModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MatIconModule,
        MatDividerModule,
        MatDialogModule,
        MatSelectModule,
        MatMenuModule,
        ShoppingcartModule,
        MatButtonModule,
        MatMenuModule,
        FooterModule,
        FormsModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        DragDropModule,
        FilterModule,
        MatdialogModule






    ]
})
export class BannersModule { }
